<template>
  <div>
    <div v-if="!isSupport" style="background: white" class="elevation-4 text-xs-center pa-4">
      <div class="headline">Datatable is not supported for this schema yet</div>
    </div>
    <div v-else style="background: white" :class="containerClass">
      <template v-if="!hideToolbar">
        <v-toolbar v-if="datatable.selected.length === 0" flat color="white" :class="['px-2', toolbarClass]">
          <v-toolbar-title>
            <v-flex d-flex align-center justify-center style="line-height: 1.5em !important;">
              <slot name="title">
                <span :class="['title d-inline-block my-2']">
                  {{ titleText(title || collection) }}
                </span>
              </slot>
            </v-flex>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div v-if="exportable">
          <v-btn :loading="datatable.loading"
          @click="exportData">Export to csv</v-btn>
          </div>
          <div v-if="refreshable">
            <v-btn flat icon class="btn-toolbar" @click="refreshData">
              <v-icon>cached</v-icon>
            </v-btn>
          </div>
          <MongoDataTableFilter
            v-if="filterable"
            v-model="datatable.filteredColumns"
            :flatSchema="service.flatSchema"
          />
          <MongoDataTableSelectedColumns
            v-if="columnSelectable"
            v-model="datatable.selectedColumns"
            :items="visibleColumns"
          />
          <div v-if="insertable">
            <v-btn color="pink" dark small fab @click="openAddModal()">
              <v-icon>add</v-icon>
            </v-btn>
          </div>
          <!-- <v-btn flat icon class="btn-toolbar">
            <v-icon>filter_list</v-icon>
          </v-btn> -->
        </v-toolbar>
        <v-toolbar v-else flat :style="{'background-color': '#e3f2fd'}" class="px-2">
          <v-toolbar-title class="primary--text subheading" style="font-weight: 400;">
            {{ datatable.selected.length }} items selected
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="deletable"
            :disabled="!initial || datatable.selected.length === 0"
            :loading="deleteLoading"
            flat icon class="btn-toolbar" @click="deleteSelected()">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <v-data-table
        ref="datatable"
        v-bind="dataTableProps"
        :headers="hideHeaders ? undefined : (this.headers || datatableVisibleHeaders)"
        :items="datatableItems"
        :item-key="itemKey"
        :pagination.sync="datatable.pagination"
        :total-items="offline ? undefined: datatable.pagination.totalItems"
        :loading="datatable.loading"
        :rows-per-page-items="rowsPerPageItems"
        :disable-initial-sort="sortable"
        :no-data-text="NO_DATA_TEXT"
        v-model="datatable.selected"
        :select-all="selectable"
        hide-actions
      >
        <template slot="headers" slot-scope="props">
          <slot v-if="!hideHeaders" name="headers" v-bind="props" :scope="props">
            <tr>
              <th v-if="selectable">
                <v-checkbox
                  color="pink accent-1"
                  hide-details
                  @click.native="toggleAll"
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                ></v-checkbox>
              </th>
              <th v-for="header in props.headers" :key="header.text"
                :class="['text-xs-left column sortable', datatable.pagination.descending ? 'desc' : 'asc', header.value === datatable.pagination.sortBy ? 'active' : '']"
                @click="sortable ? changeSort(header.value) : null"
                role="columnheader"
                scope="col"
              >
                {{ header.text }}
                <v-icon v-if="sortable">arrow_upward</v-icon>
              </th>
            </tr>
          </slot>
          <tr v-else style="height: 2px"><th></th></tr>
          <!-- <tr class="datatable__progress">
            <th colspan="100%" class="column">
              <v-progress-linear v-if="datatable.loading" indeterminate height="2"></v-progress-linear>
            </th>
          </tr> -->
        </template>
        <template slot="items" slot-scope="props">
          <slot name="items" v-bind="props" :scope="props">
            <tr :class="rowClass && rowClass(props)" @click.capture="$emit('click:row', props)">
              <td v-if="selectable" class="text-xs-center">
                <v-checkbox
                  v-if="!(tableRowsState[props.item._id] && tableRowsState[props.item._id].loading)"
                  color="pink accent-1"
                  hide-details
                  v-model="props.selected"
                ></v-checkbox>
                <v-progress-circular v-else indeterminate :size="24" color="grey darken-1" />
              </td>
              <td v-if="service.flatSchema[key]" v-for="(prop, key) in props.item" :key="key" :class="[{'cursor-pointer': editable}, itemClass]"
                @click.stop.prevent="editable ? openEditModal(props.item) : null"
              >
                <MongoDataTableItemField :item="prop" :itemSchema="service.flatSchema[key]" />
                <!-- <MongoEditableField
                  :title="`Update ${getHeaderText(key)}`"
                  :disabled="!getHeaderText(key)"
                  v-model="datatable.items[props.index][key]"
                  :doc=props.item
                  :field="key"
                  :service="service"
                /> -->
              </td>
            </tr>
          </slot>
        </template>
        <template slot="expand" slot-scope="props">
          <slot name="expand" v-bind="props" :scope="props"></slot>
        </template>
        <template slot="no-data">
          <td class="text-xs-center" colspan="100%">{{ datatable.loading ? LOADING_TEXT : NO_DATA_TEXT }}</td>
        </template>
        <template slot="footer">
          <slot name="tableFooter"></slot>
        </template>
      </v-data-table>
      <MongoDataTableFooter
        v-if="!hideFooters && $refs.datatable"
        :rowsPerPageItems="rowsPerPageItems"
        :pagination.sync="datatable.pagination"
      />
      <MongoAddEditModalDataTable
        v-if="insertable"
        ref="addModal"
        v-model="addForm"
        :service="service"
        :discriminators="discriminators"
        :discriminatorKey="discriminatorKey"
        :onInsert="onInsert"
        @updated="refreshData()"
        @close="addForm = {}"
        @submit="(form, next) => $emit('insert', form, next)"
        />
      <MongoAddEditModalDataTable
        v-if="editable"
        ref="editModal"
        :title="readonly ? 'Item Details' : 'Edit item'"
        v-model="editForm"
        :service="service"
        :discriminators="discriminators"
        :discriminatorKey="discriminatorKey"
        editMode
        :deletable="deletable"
        :copyable="copyable"
        :readonly="readonly"
        :onEdit="onEdit"
        :onDelete="onDelete"
        @updated="refreshData()"
        @copied="onEditDialogCopied"
        @submit="(form, next) => $emit('edit', form, next)"
        @delete="(form, next) => $emit('delete', form, next)"
        />
    </div>
  </div>
</template>

<script>
  import MessageDialog from '../../libs/message-dialog/'
  import MongoConnector from '../../services/mongo-connector.service'
  import { getTableHeaders, prepareTableData, FIELD_ID, HIDDEN_FIELDS_FOR_UPDATE, parseMongoQueryByFilterableObject, createSchemaFromDocuments, LOADING_TEXT, NO_DATA_TEXT, filterMongoItems } from '../../libs/mongo-datatable'
  import { debouncePromise, titleText, deepmerge, getProp, debounce } from '../../libs/utils'
  import MongoDataTableFilter from './MongoDataTableFilter.vue'
  import MongoDataTableSelectedColumns from './MongoDataTableSelectedColumns'
  import MongoEditableField from './MongoEditableField'
  import MongoAddEditModalDataTable from './MongoAddEditModalDataTable'
  import MongoDataTableItemField from './MongoDataTableItemField'
  import MongoDataTableFooter from './MongoDataTableFooter'
  import { exportCsv } from '../../services/export-csv'

  const defaultRowsPerPageItems = [50, 100, 200, 500]
  export default {
    props: {
      database: { type: String, required: false, default: '' },
      collection: { type: String, required: false, default: '' },
      schema: { type: Object, required: false, default: () => ({}) },
      discriminators: { type: Object, required: false, default: null },
      discriminatorKey: { type: String, required: false, default: null },
      autoSchema: { type: Boolean, required: false, default: false },
      offline: { type: Boolean, required: false, default: false },
      title: { type: String, required: false, default: null },
      itemKey: { type: String, required: false, default: FIELD_ID },
      headers: { type: Array, required: false, default: null },
      items: { type: Array, required: false, default: () => [] },
      toolbarClass: { type: [String, Object, Array], required: false, default: undefined },
      containerClass: { type: [String, Object, Array], required: false, default: 'elevation-1' },
      rowClass: { type: Function, required: false, default: undefined },
      itemClass: { type: [String, Object, Array], required: false, default: undefined },
      dataTableProps: { type: Object, required: false, default: () => ({}) },
      insertable: { type: Boolean, required: false, default: true },
      editable: { type: Boolean, required: false, default: true },
      readonly: { type: Boolean, required: false, default: false },
      copyable: { type: Boolean, required: false, default: true },
      deletable: { type: Boolean, required: false, default: true },
      selectable: { type: Boolean, required: false, default: true },
      exportable: { type: Boolean, required: false, default: true },
      refreshable: { type: Boolean, required: false, default: true },
      filterable: { type: Boolean, required: false, default: true },
      columnSelectable: { type: Boolean, required: false, default: true },
      sortable: { type: Boolean, required: false, default: true },
      rowsPerPageItems: { type: Array, required: false, default: () => defaultRowsPerPageItems },
      rowsPerPage: { type: Number, required: false, default: defaultRowsPerPageItems[0] },
      countable: { type: Boolean, required: false, default: true },
      syncUserState: { type: Boolean, required: false, default: true },
      syncUserStateKey: { type: String, required: false, default: undefined },
      hideToolbar: { type: Boolean, required: false, default: false },
      hideHeaders: { type: Boolean, required: false, default: false },
      hideFooters: { type: Boolean, required: false, default: false },
      onFetch: { type: Function, required: false, default: null },
      onTableItems: { type: Function, required: false, default: null },
      onCount: { type: Function, required: false, default: null },
      onRefresh: { type: Function, required: false, default: null },
      onInsert: { type: Function, required: false, default: null },
      onEdit: { type: Function, required: false, default: null },
      onDelete: { type: Function, required: false, default: null }
    },
    data () {
      const data = {
        initial: false,
        service: null,
        initialItems: [],
        deleteLoading: false,
        addForm: {},
        editForm: {},
        visibleColumns: [],
        tableRowsState: {},
        datatable: {
          items: [],
          selected: [],
          loading: false,
          pagination: {
            descending: true,
            page: 1,
            rowsPerPage: this.rowsPerPage,
            sortBy: this.sortable ? 'created_at' : null,
            totalItems: 0
          },
          selectedColumns: [],
          filteredColumns: []
        },
        LOADING_TEXT,
        NO_DATA_TEXT
      }
      this.initDataComponent(data)
      return data
    },
    watch: {
      'schema': {
        deep: true,
        async handler (val) {
          this.service = new MongoConnector(this.database, this.collection, val)
        }
      },
      'items': {
        deep: true,
        async handler (val) {
          this.$nextTick(() => {
            this.initDataComponent(this)
            this.$nextTick(async () => {
              this.initial && await this.refreshData()
            })
          })
        }
      },
      'datatable.pagination': {
        async handler () {
          if (!this.offline) {
            this.initial && await this.refreshData()
          }
        },
        deep: true
      },
      'datatable.pagination.rowsPerPage': {
        async handler () {
          this.$nextTick(async () => {
            this.saveUserState()
          })
        },
        deep: true
      },
      'datatable.selectedColumns': {
        deep: true,
        async handler () {
          this.$nextTick(async () => {
            this.initial && await this.refreshData()
            this.saveUserState()
          })
        }
      },
      'datatable.filteredColumns': {
        deep: true,
        async handler () {
          this.$nextTick(async () => {
            this.initial && await this.refreshData()
            this.saveUserState()
          })
        }
      }
    },
    computed: {
      isSupport () {
        return true
      },
      datatableHeaders () {
        return this.hideHeaders
        ? []
        : getTableHeaders(this.service.flatSchema)
      },
      datatableHeadersMap () {
        return this.datatableHeaders.reduce((c, h) => {
          c[h.value] = h
          return c
        }, {})
      },
      datatableVisibleHeaders () {
        return this.datatableHeaders.filter(header => {
          return this.datatable.selectedColumns.includes(header.value)
        })
      },
      datatableVisibleHeadersValue () {
        return this.datatableVisibleHeaders.map(({value}) => value)
      },
      datatableItems () {
        if (this.onTableItems) {
          return this.onTableItems(this.datatable.items)
        }
        /**
         * Filter selected columns
        */
        return this.datatable.items.map(item => {
          return Object.keys(item).reduce((c, key) => {
            if (
              this.datatable.selectedColumns.includes(key) ||
              key === FIELD_ID
              // || HIDDEN_FIELDS_FOR_UPDATE.includes(key)
            ) {
              c[key] = item[key]
            }
            return c
          }, {})
        })
      }
    },
    created () {
      this.countDataFromService = debouncePromise(() => {
        let getCountFn
        if (this.offline) {
          getCountFn = Promise.resolve(this.datatableItems.length)
        } else {
          if (this.countable) {
            const params = this.getServiceParameters()
            params['skip'] = null
            getCountFn = this.onCount ? this.onCount(this, params) : this.service.count(params)
          } else {
            getCountFn = Promise.resolve(0)
          }
        }
        return getCountFn.then(count => {
          this.datatable.pagination.totalItems = count
        })
      }, 2000)
    },
    async beforeMount () {
      if (!this.isSupport) return
      await this.restoreUserState()
      await this.refreshData()
    },
    methods: {
      async exportData() {
        exportCsv(this.datatable.items, this.service.collection, this.datatable.pagination.page)
      },
      initDataComponent (dataObj) {
        let schema = this.schema
        if (this.offline) {
          if (this.autoSchema) {
            schema = createSchemaFromDocuments(this.items)
          }
        }
        const service = new MongoConnector(this.database, this.collection, schema)
        const visibleColumns = Object.keys(service.flatSchema).filter(
          key => !getProp(service.flatSchema[key], ['gsr_dashboard', 'hideColumn'], false),
        )
        dataObj.service = service
        dataObj.visibleColumns = visibleColumns
        dataObj.datatable.selectedColumns = [...visibleColumns]
      },
      async restoreUserState () {
        if (this.syncUserState) {
          const state = this.$store.getters['user/datatable']
          const target = getProp(
            state,
            this.syncUserStateKey || [this.service.database, this.service.collection],
            {}
          )
          const defaultConfig = getProp(target, '$_DEFAULT', {})
          delete target['$_DEFAULT']
          this.datatable = deepmerge(this.datatable, target)
          this.datatable.selectedColumns = this.datatable.selectedColumns.filter(
            key => this.visibleColumns.includes(key)
          )
          if (defaultConfig.rowsPerPage && this.rowsPerPageItems.includes(defaultConfig.rowsPerPage)) {
            this.datatable.pagination.rowsPerPage = defaultConfig.rowsPerPage
          }
        }
      },
      saveUserState: debounce(async function () {
        if (this.syncUserState) {
          const { selectedColumns, filteredColumns, pagination } = this.datatable
          const data = {}
          if (this.columnSelectable) data.selectedColumns = selectedColumns
          if (this.filterable) data.filteredColumns = filteredColumns
          data['$_DEFAULT'] = {
            rowsPerPage: pagination.rowsPerPage
          }
          await this.$store.dispatch(
            'user/setDatatable',
            this.syncUserStateKey
            ? { [this.syncUserStateKey]: data }
            : { [this.service.database]: { [this.service.collection]: data } }
          )
        }
      }, 20),
      async setLoader (val) {
        this.datatable.loading = val
      },
      async setItems (val, force = false) {
        this.initialItems = force ? val : prepareTableData(this.datatableVisibleHeadersValue, val)
        this.datatable.items = [...this.initialItems]
      },
      async setSelectedColumns (columns = []) {
        this.datatable.selectedColumns = columns
      },
      async refreshData () {
        try {
          if (this.onRefresh) {
            this.onRefresh(this)
          } else {
            this.datatable.loading = true
            const promises = [this.getDataFromService()]
            if (!this.initial) {
              promises.push(this.countDataFromService())
            } else {
              this.countDataFromService()
            }
            await Promise.all(promises)
            this.datatable.loading = false
          }
        } catch (e) {
          console.error(e)
          this.datatable.loading = false
        }
        this.initial = true
      },
      getServiceParameters () {
        const { sortBy, descending, page, rowsPerPage } = this.datatable.pagination
        return {
          filter: parseMongoQueryByFilterableObject(this.datatable.filteredColumns),
          sort: sortBy
            ? { [sortBy]: descending ? -1 : 1 }
            : {},
          limit: rowsPerPage,
          skip: (page - 1) * rowsPerPage,
          projection: this.datatable.selectedColumns.reduce((c, column) => {
            c[column] = 1
            return c
          }, {})
        }
      },
      async getDataFromService () {
        let items
        if (this.onFetch) {
          items = await this.onFetch(this)
        } else {
          if (this.offline) {
            items = [...this.items]
            items = this.findOffline(items)
          } else {
            items = await this.service.find(this.getServiceParameters())
          }
          items = prepareTableData(this.datatableVisibleHeadersValue, items)
        }
        this.initialItems = items
        this.datatable.items = [...this.initialItems]
      },
      toggleAll () {
        if (this.datatable.selected.length) this.datatable.selected = []
        else this.datatable.selected = this.datatable.items.slice()
      },
      changeSort (column) {
        if (this.datatable.pagination.sortBy === column) {
          this.datatable.pagination.descending = !this.datatable.pagination.descending
        } else {
          this.datatable.pagination.sortBy = column
          this.datatable.pagination.descending = false
        }
      },
      openAddModal () {
        this.$refs.addModal.open()
      },
      async openEditModal (item) {
        const id = item._id
        this.datatable.loading = true
        this.tableRowsState[id] = { loading: true }
        try {
          if (this.offline) {
            if (id !== undefined) {
              item = this.datatableItems.find(_item => _item[FIELD_ID] === id)
            }
            this.editForm = item || {}
          } else {
            if (id !== undefined) {
              item = await this.service.findById(id)
            }
            this.editForm = item || {}
          }
          this.$nextTick(() => this.$refs.editModal.open())
        } catch (e) {
          console.error(e)
        }
        delete this.tableRowsState[id]
        this.datatable.loading = false
      },
      async onEditDialogCopied (form) {
        this.$refs.editModal.close()
        setTimeout(() => {
          this.addForm = form
          this.openAddModal()
        }, 500)
      },
      async deleteSelected () {
        // FIXME: deleteSelected for offline
        try {
          const { value: value } = await MessageDialog.showWarningMessage()
          if (value && value !== '') {
            this.deleteLoading = true
            const response = await this.service.deleteDocuments(this.datatable.selected, value)
            console.log(response)
            this.datatable.selected = []
            this.refreshData()
          }
        } catch (e) {
          console.error(e)
        }
        this.deleteLoading = false
      },
      getHeaderText (field) {
        if (HIDDEN_FIELDS_FOR_UPDATE.includes(field)) {
          return null
        }
        return this.datatableHeadersMap[field].text
      },
      titleText (text) {
        return titleText(text)
      },
      findOffline (items) {
        return filterMongoItems(items, this.datatable.filteredColumns, this.datatable.pagination)
      }
    },
    components: {
      MongoDataTableFilter,
      MongoDataTableSelectedColumns,
      MongoEditableField,
      MongoAddEditModalDataTable,
      MongoDataTableItemField,
      MongoDataTableFooter
    }
  }
</script>
